import { flexColumn } from '$styles/common.css'
import { TID, UserStatusHistories } from '$services/api'
import { useApiListingParams } from '$hooks/actions'
import { FC, useEffect, useState } from 'react'
import Loading from '$components/Loading'
import EmptyData from '$components/EmptyData'
import { useUserService } from '$hooks/services'
import TimelineItem from '$components/TimelineItem'
import ScrollPagination from '$components/ScrollPagination'

const PER_PAGE = 10

type Props = {
  userId?: TID
  appId?: TID
}
const StatusHistory: FC<Props> = ({ userId, appId }) => {
  const [histories, setHistories] = useState<UserStatusHistories[]>([])

  const { userStatusHistores } = useUserService()

  const { data, fetchUserStatusHistories, fetchingUserStatusHistories } =
    userStatusHistores

  const { meta } = { ...data }

  const { pagerProps } = useApiListingParams({
    total: meta?.total,
    perPage: PER_PAGE
  })

  const { currentPage, jump } = pagerProps

  useEffect(() => {
    if (!userId) return
    fetchUserStatusHistories({
      userId,
      isAdmin: false,
      page: currentPage,
      per_page: PER_PAGE,
      application_id: appId
    }).then(({ data }) => {
      setHistories(prev => (currentPage === 1 ? data : [...prev, ...data]))
    })
  }, [userId, currentPage, fetchUserStatusHistories, appId])

  const isEmpty = !histories.length && !fetchingUserStatusHistories

  const initialLoading =
    currentPage === 1 && fetchingUserStatusHistories && !histories.length

  return (
    <>
      {initialLoading && (
        <article className={flexColumn} style={{ minHeight: 300 }}>
          <Loading />
        </article>
      )}

      {isEmpty && (
        <article className={flexColumn} style={{ minHeight: 300 }}>
          <EmptyData type="user status histories" />
        </article>
      )}

      <article className={flexColumn}>
        {histories.map(history => {
          const title = (() => {
            const changedStatus = history.log_details?.new_value?.status
            if (changedStatus === 'active') {
              return 'Activated the user'
            }

            return 'Deactivated the user'
          })()
          return (
            <TimelineItem
              key={history.id}
              title={title}
              date={history.created_at}
              email={history.created_by.email}
              role={history.created_by.role}
            />
          )
        })}
      </article>

      <ScrollPagination
        loading={fetchingUserStatusHistories}
        onTrigger={jump}
        meta={meta}
      />
    </>
  )
}

export default StatusHistory
